import React from 'react';

import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { scanIqRegistrationService } from '../../../../auth-management';
import { RegistrationFormAccessWidget } from '../../../../auth-management/components/RegistrationFormAccessWidget/RegistrationFormAccessWidget';

const CoachScanIqRegistrationTab = () => {
  const entityId = loggedInUserDataStore.getEntityId();

  return (
    <RegistrationFormAccessWidget
      id={entityId}
      getRegistrationLink={scanIqRegistrationService.getRegistrationLink}
      getRegistrationQrCode={scanIqRegistrationService.getRegistrationQrCode}
      qrCodeDescription="A QR code has already been generated and assigned to your entity"
    />
  );
};

export { CoachScanIqRegistrationTab };
